import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="privacy-policy-container">
      <h1>{t('privacy.title')}</h1>
      <p className="last-updated">{t('privacy.lastUpdated', { date: '2025-01-01' })}</p>

      <section>
        <p>{t('privacy.intro')}</p>
      </section>

      <section>
        <h2>{t('privacy.dataCollection')}</h2>
        <p>{t('privacy.dataCollectionText')}</p>
      </section>

      <section>
        <h2>{t('privacy.dataUse')}</h2>
        <p>{t('privacy.dataUseText')}</p>
      </section>

      <section>
        <h2>{t('privacy.dataSharing')}</h2>
        <p>{t('privacy.dataSharingText')}</p>
      </section>

      <section>
        <h2>{t('privacy.dataRetention')}</h2>
        <p>{t('privacy.dataRetentionText')}</p>
      </section>

      <section>
        <h2>{t('privacy.yourRights')}</h2>
        <p>{t('privacy.yourRightsText')}</p>
      </section>

      <section>
        <h2>{t('privacy.contact')}</h2>
        <p>{t('privacy.contactText')}</p>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
